var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{directives:[{name:"bg-typography",rawName:"v-bg-typography",value:('body-m'),expression:"'body-m'"}],staticClass:"video-upload-warning"},[_c('bg-field',{staticClass:"bg-field--zero-margin",attrs:{"label":"Please upload the video below"}},[_vm._v("\n    When you have uploaded the video, we can start the process\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }